<template>
    <div>
        <datatable-filter v-show="datatable.filterStatus"
                           @filter="filter"
                           @filterClear="filterClear">
            <b-row>
                <b-col sm="6" md="4">
                    <b-form-group :label="$t('coop_event_name')">
                        <b-form-input v-model="datatable.queryParams.filter.event_name" />
                    </b-form-group>
                </b-col>
                <b-col sm="6" md="4">
                    <b-form-group :label="$t('coop_company')">
                        <b-form-input v-model="datatable.queryParams.filter.company_name" />
                    </b-form-group>
                </b-col>
            </b-row>
        </datatable-filter>
        <datatable :isLoading.sync="datatable.isLoading"
                   :columns="datatable.columns"
                   :rows="datatable.rows"
                   :total="datatable.total"
                   :queryParams="datatable.queryParams"
                   :lineNumbers="false"
                   @on-page-change="onPageChange"
                   @on-sort-change="onSortChange"
                   @on-per-page-change="onPerPageChange"
                   v-show="datatable.showTable"
        />
    </div>
</template>

<script>
    //Component
    import DatatableFilter from '@/components/datatable/DatatableFilter';
    import Datatable from '@/components/datatable/Datatable';

    //Service
    import CoopEventService from '@/services/CoopEventService';

    //Other
    import qs from 'qs';

    export default {
        name: 'Events',
        components: {
            DatatableFilter,
            Datatable
        },
        data() {
            return {
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: '',
                            field: 'buttons',
                            html: true,
                            hidden: false,
                            tdClass: 'p-0 text-center w-40 align-middle',
                            buttons: [
                                {
                                    text: this.$t('coop_event_join'),
                                    class: 'ri-calendar-check-line',
                                    callback: (row) => {
                                        this.joinEvent(row);
                                    }
                                }
                            ]
                        },
                        {
                            label: this.toUpperCase('coop_event_name'),
                            field: 'event_name',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('coop_event_type'),
                            field: 'event_type',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('coop_company'),
                            field: 'company_name',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('date'),
                            field: 'date',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('coop_event_time'),
                            field: 'time',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('coop_event_format'),
                            field: 'event_format',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('coop_quota'),
                            field: 'quota',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('status'),
                            field: 'status',
                            formatFn: (status) => {
                                return status === 'active' ? this.$t('active') : status;
                            },
                            hidden: false
                        }
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        filter: {},
                        sort: 'id',
                        page: 1,
                        limit: 20
                    }
                }
            };
        },
        methods: {
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            filterClear() {
                this.datatable.queryParams.filter = {};
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == 'desc' ? '-' : '';
                this.datatable.queryParams.sort = sortType + params[0].field;
                this.getRows();
            },
            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, { encode: false })
                };

                return CoopEventService.getAll(config)
                    .then((response) => {
                        this.datatable.rows = response.data.data;
                        this.datatable.total = response.data.pagination.total;
                    })
                    .finally(() => {
                        this.datatable.isLoading = false;
                    });
            },
            joinEvent(row) {
                CoopEventService.join(row.id).then(() => {
                    this.$toast.success(this.$t('coop_event_joined_success'));
                    this.getRows();
                });
            }
        },
        created() {
            this.getRows();
        }
    };
</script>
